<template>
    <div>
        <footer>
            <div class="index-content">
                <div class="footer-logo">
                    <div class="footer-logo-image">
                        <img :src="config.logo_footer">
                    </div>
                    <div class="footer-logo-info">
                        <div class="footer-title">
                            {{config.company_name}}
                        </div>
                        <div class="footer-add">
                            ADD：{{config.address}}
                        </div>
                        <div class="footer-tel">
                            TEL：{{config.tel}}
                        </div>
                    </div>
                </div>

                <div class="footer-list">
                    <div class="footer-link">
                        <a :href="item.item_url" target="_blank" v-for="(item,index) in link"
                            :key="index">{{item.item_name}}</a>
                    </div>

                    <div class="footer-list-content" v-for="(item,index) in data" :key="index">
                        <div class="footer-list-top">
                            <img :src="item.item_image">
                            <p>{{item.item_name}}</p>
                        </div>
                        <ul>
                            <li v-for="(item2,index2) in item.child" :key="index2">
                                <a :href="item2.item_url">{{item2.item_name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="footer-qr">
                    <img :src="config.qr">
                </div>

                <div class="footer-copy">
                    <div class="footer-copy-no">
                        <a href="http://beian.miit.gov.cn/" target="_blank">{{config.icp}}</a>
                    </div>
                    <div class="footer-copy-info">
                        Copyright © 2015-{{year}} {{config.copyright}} 版权所有
                    </div>
                    <div class="icp2">
                        <a target="_blank"
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61010302000719"
                            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                            <img src="@/static/image/beian.png" style="float:left;" />
                            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
                                陕公网安备 61010302000719号</p>
                        </a>
                    </div>
                </div>

            </div>

        </footer>

    </div>
</template>

<script>
    import { common_nav, common_config } from '@/api/common.js';
    export default {
        name: 'commonFooter',
        data() {
            return {
                data: [],
                link: [],
                config: {},
            }
        },
        created() {
            this.get_data();
            this.get_link();
            this.get_config();
        },
        computed:{
            year(){
                var date = new Date();
                return date.getFullYear();
            },
        },
        methods: {
            get_data() {
                common_nav({ alias: 'index_footer' }).then(res => {
                    if (res.code == 200) {
                        this.data = res.data;
                    }
                });
            },

            get_link(){
                common_nav({ alias: 'link' }).then(res => {
                    if (res.code == 200) {
                        this.link = res.data;
                    }
                });
            },

            get_config() {
                common_config({}).then(res => {
                    if (res.code == 200) {
                        this.config = res.data;
                    }
                });
            },

            url(path) {
                if (path.indexOf("http") != -1) {
                    window.location.href = path;
                } else {
                    this.$router.push(path);
                }
            },
        }
    }
</script>
<style scoped>
    .index-content {
        width: 1300px;
        margin: 0 auto;
    }

    a{
        text-decoration: none;
    }

    footer {
        height: 480px;
        background: #fff;
        width: 100%;
        min-width: 1200px;
    }

    footer .index-content {
        position: relative;
        height: 480px;
    }

    .footer-logo {
        width: 300px;
        height: 350px;
        position: absolute;
        left: 0;
        top: 50px;
    }

    .footer-logo-image img {
        height: 70px;
    }

    .footer-list {
        width: 700px;
        height: 220px;
        position: absolute;
        left: 300px;
        top: 70px;
    }

    .footer-list-content {
        display: inline-block;
        border-right: 1px solid #aaa;
        text-align: center;
        width: 160px;
    }

    .footer-list-content ul {
        margin-top: 30px;
    }


    .footer-list-content ul a {
        font-size: 16px;
        color: #888;
        text-decoration: none;
    }

    .footer-list-content ul li {
        margin-bottom: 10px;
    }

    .footer-list-top p {
        font-size: 18px;
        font-weight: 600;
    }

    .footer-list-top img {
        height: 32px;
    }

    .footer-logo-info {
        margin-top: 40px;
    }


    .footer-logo-info .footer-title {
        font-size: 18px;
        font-weight: 800;
    }


    .footer-logo-info .footer-add {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 200;
    }

    .footer-logo-info .footer-tel {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 200;
    }




    .footer-qr {
        position: absolute;
        right: 0;
        top: 130px;
        width: 200px;

    }

    .footer-qr img {
        width: 125px;
    }


    .footer-copy {
        text-align: center;
        position: absolute;
        height: 100px;
        width: 1200px;
        left: 0;
        bottom: 0;
        color: #666;
    }

    .footer-copy-no a {
        color: #666;
    }

    .footer-link {
        height: 50px;
        padding-left: 40px;
    }

    .footer-link a {
        font-size: 16px;
        margin-right: 30px;
        color: #888;
    }

    .icp2 {
        width: 300px;
        margin: 0 auto;
        padding: 20px 0;
    }
</style>